// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YhAG4w06HxG887FC40Ao {
  --top-header-height: 4.5rem;
  --top-margin: 1.5rem;

  width: 100%;
  border-top-right-radius: 1.25rem;
  border-top-left-radius: 1.25rem;
  max-width: 61.25rem;
  margin: var(--top-margin) auto 0;
}

.Mqh4Gct24Vzw9ewE4Gx7 {
  height: calc(100% - var(--top-margin) - var(--top-header-height) - 3.25rem);
  padding: 2.6875rem 3.4375rem 4.375rem 3.25rem;
}

.Nfno5jCkqlGadZ1aRQXN {
  --top-header-height: 4.5rem;

  position: relative;
  height: var(--top-header-height);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 3.25rem;
  padding: 0 4.0625rem;
}

.Nfno5jCkqlGadZ1aRQXN.QrcjdxdqOzxlGqocO8NH {
  justify-content: start;
  align-items: start;
  grid-gap: 1.25rem;
  gap: 1.25rem;
  margin-bottom: 2.6875rem;
}

.ANEFtqYpp55tqfnpDQdg {
  color: #bdbdbd;
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .Nfno5jCkqlGadZ1aRQXN {
    margin-top: 1.5625rem;
    padding: 0 4.0625rem 0 1.5625rem;
  }

  .Mqh4Gct24Vzw9ewE4Gx7 {
    padding: 1.5625rem;
  }

  .Nfno5jCkqlGadZ1aRQXN.QrcjdxdqOzxlGqocO8NH {
    flex-direction: column;
  }
}

@media only screen and
  (max-width: 639px) {
  .Nfno5jCkqlGadZ1aRQXN {
    margin-top: 1.5625rem;
    padding: 0 2.8125rem 0 0.9375rem;
  }

  .Mqh4Gct24Vzw9ewE4Gx7 {
    padding: 1.5625rem 0.9375rem;
  }

  .Nfno5jCkqlGadZ1aRQXN.QrcjdxdqOzxlGqocO8NH {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BusinessPDPModalForm/BusinessPDPModalForm.module.css"],"names":[],"mappings":"AAAA;EACE,2BAAyB;EACzB,oBAAkB;;EAElB,WAAW;EACX,gCAA6B;EAC7B,+BAA4B;EAC5B,mBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2EAAwE;EACxE,6CAA4B;AAC9B;;AAEA;EACE,2BAAyB;;EAEzB,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAgB;EAChB,oBAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAS;EAAT,YAAS;EACT,wBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EACE;IACE,qBAAgB;IAChB,gCAAsB;EACxB;;EAEA;IACE,kBAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;;EACE;IACE,qBAAgB;IAChB,gCAAsB;EACxB;;EAEA;IACE,4BAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".modalContentWrapper {\n  --top-header-height: 72px;\n  --top-margin: 24px;\n\n  width: 100%;\n  border-top-right-radius: 20px;\n  border-top-left-radius: 20px;\n  max-width: 980px;\n  margin: var(--top-margin) auto 0;\n}\n\n.modalContent {\n  height: calc(100% - var(--top-margin) - var(--top-header-height) - 52px);\n  padding: 43px 55px 70px 52px;\n}\n\n.modalHeader {\n  --top-header-height: 72px;\n\n  position: relative;\n  height: var(--top-header-height);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 52px;\n  padding: 0 65px;\n}\n\n.modalHeader.withUsps {\n  justify-content: start;\n  align-items: start;\n  gap: 20px;\n  margin-bottom: 43px;\n}\n\n.closeButton {\n  color: #bdbdbd;\n}\n\n@media (--tablet) {\n  .modalHeader {\n    margin-top: 25px;\n    padding: 0 65px 0 25px;\n  }\n\n  .modalContent {\n    padding: 25px;\n  }\n\n  .modalHeader.withUsps {\n    flex-direction: column;\n  }\n}\n\n@media (--mobile) {\n  .modalHeader {\n    margin-top: 25px;\n    padding: 0 45px 0 15px;\n  }\n\n  .modalContent {\n    padding: 25px 15px;\n  }\n\n  .modalHeader.withUsps {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContentWrapper": `YhAG4w06HxG887FC40Ao`,
	"modalContent": `Mqh4Gct24Vzw9ewE4Gx7`,
	"modalHeader": `Nfno5jCkqlGadZ1aRQXN`,
	"withUsps": `QrcjdxdqOzxlGqocO8NH`,
	"closeButton": `ANEFtqYpp55tqfnpDQdg`
};
export default ___CSS_LOADER_EXPORT___;
